__webpack_require__.p = "https://animal-info.weenect.com/";